import { EnrolledSubmodulesService } from '@/services/undergrad/mamata/enrolled-submodules.service';
import { StellateSubmodulesReaderService } from '@/services/undergrad/stellate/stellate-submodules-reader.service';
import { UndergradModule } from '@/models/undergrad/undergrad-module.model';

export class SubmodulesReaderService {
  public static async getSubmodules(courseId: string): Promise<UndergradModule[]> {
    const enrolledSubmodulesIds: string[] =
      await EnrolledSubmodulesService.getUserEnrolledSubmodules(courseId);

    const submodulesInfo = await StellateSubmodulesReaderService.getSubmodulesByIdList(
      enrolledSubmodulesIds,
    );

    return submodulesInfo;
  }
}
